import clsx from 'clsx';
import { formatInTimeZone } from 'date-fns-tz';
import moment from 'moment';
import React, { useCallback } from 'react';

import useServerSideRendering from '@hooks/useServerSideRendering';
import { HOME_TIME_ZONE, articleTime } from '@utils/dates';

interface TimeAgoProps {
  className?: string;
  date: string;
  timeFromNow?: boolean;
}

export default function TimeAgo({ className, date, timeFromNow = false }: TimeAgoProps) {
  const hydrated = useServerSideRendering();

  const publishTime = useCallback(() => {
    if (!date) return;

    if (timeFromNow) {
      return moment(date).fromNow();
    } else if (moment(date).isSame(new Date(), 'day')) {
      return articleTime(date);
    }

    return formatInTimeZone(new Date(date), HOME_TIME_ZONE, 'MMM d, yyyy');
  }, [date, timeFromNow]);

  return (
    <time className={clsx('text-disclosure-sm', className)} title={date} dateTime={date}>
      {hydrated && publishTime()}
    </time>
  );
}
